import styled from 'styled-components';

import { brandLight, grey30, grey5, grey50, white } from 'variables/colors';
import { border, borderRadius, boxShadowHeavy } from 'variables/general';
import { fontWeightSemiBold } from 'variables/font';
import { index10 } from 'variables/z-index';

export const Component = styled.div``;

export const Overview = styled.div`
  display: flex;
  margin-bottom: 1.5em;
`;

export const OverviewDetails = styled.div`
  margin-right: 3em;
`;

export const DetailsTitle = styled.h5`
  margin-bottom: 1.5em;
`;

export const Details = styled.p``;

export const SearchWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: ${index10};
  margin-bottom: 2em;
  padding-bottom: 1.5em;
  background: linear-gradient(white 0%, white 80%, transparent 100%);
`;

export const SearchBar = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75em;
  border: ${border};
  border-radius: ${borderRadius};
`;

export const Search = styled.input`
  flex-grow: 1;
  margin-left: 0.5em;
  font-size: 0.875em;
  border: 0;

  &:focus {
    border: 0;
    outline: 0;
  }

  &::placeholder {
    color: ${grey30};
    font-weight: ${fontWeightSemiBold};
  }
`;
